import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type Header } from '@tanstack/react-table';
import { debounce } from 'lodash';

import { TextInput } from '../../../../TextInput';
import { EFilterType } from '../../../types/table';

export interface IIncludesStringFilterProps {
    header: Header<any, unknown>;
    type: EFilterType;
    inline?: boolean;
}

export const IncludesStringFilter: React.FC<IIncludesStringFilterProps> = ({ header: { column }, inline = false }) => {
    const [value, setValue] = useState<string>((column.getFilterValue() as string) || '');
    const { t } = useTranslation();

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        const searchValue = e.currentTarget.value;
        setFilterValueDebounced(searchValue);
        setValue(searchValue);
    };

    const setFilterValueDebounced = useCallback(
        debounce((value) => {
            column.setFilterValue(value);
        }, 300),
        [],
    );

    // Replace local value with the value from the column if it was changed
    useEffect(() => {
        const filterValue = column.getFilterValue();
        if (!filterValue) {
            return setValue('');
        }
        if (typeof filterValue === 'string') {
            return setValue(filterValue);
        }
    }, [column.getFilterValue()]);

    return (
        <TextInput
            placeholder={t(inline ? 'table.filtering.containsShort' : 'table.filtering.contains')}
            size={inline ? 'small' : 'medium'}
            value={value}
            onChange={handleChange}
        />
    );
};
